function wrap_img_fluid(el){
  var img_in_el = el + " img";
    $(img_in_el).each(function(){
      if($(this).hasClass("img-fluid") != true ){
        $(this).addClass('img-fluid');
      }
    });
}

export default wrap_img_fluid;